import * as yup from 'yup';

const setEmailAccountValidationForm = yup.object({
  username: yup
    .string()
    .required("Username is required")
    .nonNullable("Username is required"),
});
  
export {
    setEmailAccountValidationForm
}